<template>
  <div class="action-plan-security-devices-form">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <p class="lead">{{ !printing ? 'Definir' : ''}} Detalhes Para Dispositivo(s) de Segurança</p>
          <div v-if="!printing" class="d-flex">
            <router-link
              to="/action-plan/form"
              class="btn btn-success"
            >
              <font-awesome-icon :icon="['fas', 'arrow-left']"></font-awesome-icon>
              Voltar ao Plano de Ação
            </router-link>
            <div class="save-button ml-3">
              <button @click="save()" class="btn btn-primary">Definir</button>
            </div>
          </div>
        </div>

        <div class="col-12 d-flex justify-content-center">
          <div class="mt-4 w-50">
            <div class="col-12 col-xl-12 break-after">
              <div class="row">
                <div class="col-12 col-md-6">
                  <div class="form-group d-flex flex-column" style="height: 100%">
                    <div class="form-title mb-2">
                      Selecionar modelo de dispositivo desejado
                    </div>

                    <custom-multistep-selector
                      v-if="!loadingDevices"
                      :options="securityDevicesGrouped"
                      :value="deviceModel"
                      @item-selected-event="setDeviceModel"
                    />
                  </div>
                </div>

                <div class="col-12 col-md-6">
                  <div class="form-group mb-0">
                    <label>Descrever objetivo da instalação</label>
                    <textarea
                      v-model="goal"
                      type="text"
                      class="form-control"
                      rows="10"
                      style="height: auto"
                    ></textarea>
                  </div>
                </div>
              </div>

              <div class="form-group mt-3">
                <label>Obs. adicional</label>
                <textarea
                  v-model="observations"
                  type="text"
                  class="form-control"
                  rows="10"
                  style="height: auto"
                ></textarea>
              </div>

              <div class="selected-device-table" v-if="!printing">
                <table class="selected-device-table__table">
                  <thead>
                    <tr>
                      <th>Dispositivo <br />selecionado</th>
                      <th>Especificações <br />desejadas</th>
                      <th>Categoria de <br />segurança</th>
                      <th>Preferência por fabricante?</th>
                      <th>Algum modelo em específico?</th>
                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody v-if="selectedDevices">
                    <tr v-for="device in selectedDevices" :key="device.id">
                      <td>{{ device?.name || '-' }}</td>
                      <td>
                        <div class="form-group">
                          <input
                            v-model="device.specifications"
                            type="text"
                            class="form-control"
                          />
                        </div>
                      </td>
                      <td>
                        <div class="form-group">
                          <input
                            v-model="device.security_category"
                            type="text"
                            class="form-control"
                          />
                        </div>
                      </td>
                      <td>
                        <div class="form-group">
                          <input
                            v-model="device.manufacturer"
                            type="text"
                            class="form-control"
                          />
                        </div>
                      </td>
                      <td>
                        <div class="form-group">
                          <input
                            v-model="device.model"
                            type="text"
                            class="form-control"
                          />
                        </div>
                      </td>
                      <td>
                        <div class="form-group">
                          <div
                            class="option option__delete"
                            @click="deleteItem(device)"
                          >
                            <font-awesome-icon
                              :icon="['fas', 'trash']"
                            ></font-awesome-icon>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="results" v-if="!printing">
                <div class="results__data">
                  <div class="results__data__title">Resultado ISO 13849-1</div>
                  <div class="results__data__content">Resultado</div>
                </div>
                <div class="results__image">
                  <img :src="METRIC_IMAGES.iso138491a" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CustomMultistepSelector from './components/CustomMultistepSelector.vue'

  import { METRIC_IMAGES } from '@/constants/images.constants.js'
  import { useRoute } from 'vue-router'

  import useSecurityDevices from '@/modules/SecurityDevices.js'
  import useSwal from '../../../modules/Swal'

  export default {
    setup(props) {
      const { params } = useRoute()

      const riskAnalysisDescriptionId = params.riskAnalysisDescriptionId || props.riskAnalysisDescriptionId

      const { listDevicesGrouped, securityDevicesGrouped, loading } =
        useSecurityDevices()

      const { showConfirmDeletionSwal, showErrorDialog, showSuccessDialog } =
        useSwal()

      return {
        METRIC_IMAGES,

        riskAnalysisDescriptionId,
        showConfirmDeletionSwal,
        showErrorDialog,
        showSuccessDialog,

        listDevicesGrouped,
        securityDevicesGrouped,
        loadingDevices: loading,
      }
    },
    components: {
      CustomMultistepSelector,
    },
    props: {
      riskAnalysisDescriptionId: {
        type: Number,
        required: false,
      },
      printing: {
        type: Boolean,
        default: false,
        required: false,
      }
    },
    data() {
      return {
        consultancy: false,

        goal: '',
        observations: '',

        selectedDevices: [],
        teste: [],

        loading: false,
      }
    },
    methods: {
      save() {
        let devicesToSave = []
        this.selectedDevices.map((x) => {
          devicesToSave.push({
            edit: x.from === 'web',
            edit_id: x.id,
            id: x.from === 'web' ? x.security_device_id : x.id,
            specifications: x.specifications || '',
            security_category: x.security_category || '',
            manufacturer: x.manufacturer || '',
            model: x.model || '',
          })
        })
        let payload = {
          risk_analysis_description_id: this.riskAnalysisDescriptionId,
          security_devices: {
            needs_consultancy: this.consultancy,
            goal: this.goal,
            observations: this.observations,
            devices: devicesToSave,
          },
        }
        this.axios
          .post(`/api/action-plan/services/security-devices`, payload)
          .then(() => {
            this.showSuccessDialog()
          })
          .catch(() => {
            this.showErrorDialog()
          })
      },
      removeFromTable(device) {
        this.selectedDevices = this.selectedDevices.filter(
          (devices) => devices.uid !== device.uid,
        )
      },
      destroyDevice(device) {
        if (device.from === 'web') {
          this.axios
            .delete(
              '/api/action-plan/services/security-devices/device/' + device.id,
            )
            .then(() => {
              this.removeFromTable(device)
            })
            .catch(() => {
              this.showErrorDialog()
            })
        } else {
          this.removeFromTable(device)
        }
      },
      deleteItem(device) {
        this.showConfirmDeletionSwal()
          .then((response) => {
            if (response.isConfirmed) {
              this.destroyDevice(device)
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },
      uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
          /[xy]/g,
          function (c) {
            let r = (Math.random() * 16) | 0,
              v = c === 'x' ? r : (r & 0x3) | 0x8
            return v.toString(16)
          },
        )
      },
      setDeviceModel(event) {
        //TODO: carregar devices do banco
        //TODO: setar device ao selecionar
        // this.selectedDevices = {
        //   ...this.selectedDevices,
        //   event.selected
        // }
        // console.log(event)

        const newDevice = {}
        newDevice[`${event.selected.id}`] = { security_device: event.selected }
        event.selected.uid = this.uuidv4()
        event.selected.from = 'local'
        this.selectedDevices.push(Object.assign({}, event.selected))
      },
      async loadDevices() {
        this.listDevicesGrouped()
      },
      async load() {
        this.loading = true

        this.axios
          .get(
            `/api/action-plan/services/${this.riskAnalysisDescriptionId}/security-devices`,
          )
          .then(({ data }) => {
            const service = data.security_devices_services[0]

            this.consultancy = data.needs_consultancy
            this.goal = service.goal
            this.observations = service.observations

            if (service.security_devices_service_devices) {
              const devices = {}
              service.security_devices_service_devices.forEach((device) => {
                device.from = 'web'
                device.name = device.security_device.name
                device.uid = this.uuidv4()
                devices[device.id] = {
                  ...device,
                }
                this.selectedDevices.push(Object.assign({}, device))
              })
            }
          })
          .catch((error) => {
            console.log({ error })
          })
          .finally(() => (this.loading = false))
      },
    },
    async mounted() {
      await this.loadDevices()
      this.load()
    },
  }
</script>

<style lang="scss" scoped>
  .selected-device-table {
    &__table {
      width: 100%;
      border: 1px solid #999;

      td,
      th,
      tr {
        border: 1px solid #999;
      }

      thead tr {
        font-size: 0.9rem;
        font-weight: bold;

        background: #ddd;
        border: 1px solid #999;

        th {
          text-align: center;
        }
      }

      tbody tr td {
        text-align: center;

        .form-group {
          margin: 0;
        }
      }
    }
  }

  .results {
    display: flex;
    border: 1px solid #a0a0a0;

    margin-top: 30px;

    &__data {
      min-width: 120px;
      display: flex;
      flex-direction: column;

      &__title {
        background-color: #707070;
        color: white;
        font-weight: bold;
        text-align: center;
      }

      &__content {
        display: flex;
        align-items: center;
        justify-content: center;

        flex-grow: 1;

        font-size: 1.4rem;
        color: #707070;
      }
    }

    &__image {
      img {
        width: 100%;
        height: auto;
      }
    }

    &__actions {
      position: absolute;

      bottom: 10px;
      right: 10px;
      width: auto;

      display: flex;

      .option {
        $defaultColor: rgb(76, 175, 80);

        cursor: pointer;

        display: flex;
        justify-content: center;
        align-items: center;

        border-radius: 50%;
        color: white;

        padding: 5px;
        width: 30px;
        height: 30px;

        border: 2px solid #ccc;
        color: $defaultColor;

        transition: box-shadow 0.5s ease, background-color 0.3s ease;

        &:hover {
          border: none;
          box-shadow: 1px 2px 8px rgb(0, 0, 0, 0.2);

          background-color: $defaultColor;

          color: white;
        }

        &:not(:first-child) {
          margin-left: 5px;
        }

        &__delete {
          color: rgb(244, 67, 54);

          &:hover {
            box-shadow: 1px 2px 8px rgb(0, 0, 0, 0.2);

            background-color: rgb(244, 67, 54);
          }
        }
      }
    }
  }
</style>
